const randomString = () => Math.round(Math.random() * 1e8).toString(36);

const uniqueId = () =>
  `${Date.now().toString(36)}-${randomString()}-${randomString()}`;

export default uniqueId;
